import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveDocumentRequestFailure({ uuid }) {
      const req = getState().find(({ document }) => document.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRemoveDocumentRequestPending({ uuid }) {
      const req = getState().find(({ document }) => document.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRemoveDocumentRequestSuccess({ uuid }) {
      const req = getState().find(({ document }) => document.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
